module.exports = __webpack_public_path__ + "img/Chance_round.626369f0.png";